import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "ExternalIcon"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "viewBox": "0 0 16 16", "xml:space": "preserve", "fill": "currentColor" } }, [_c("path", { attrs: { "d": "m9.68 1.6 1.98 1.84L5.4 9.95l.68.69 6.37-6.51s2.43 2.46 2.34 2.34c-.08-.12 1-6.18 1-6.18z" } }), _c("path", { attrs: { "d": "M.23 1.67h7.71l1.1.93-7.61.01-.06 11.06s-.12.72.93 1.02c0 0 10.05.07 10.11 0 .06-.06.93.04.96-.93.03-.96 0-6.66 0-6.66l1.14 1.1v5.56s-.12 2.01-1.65 2.01H2.15S.89 15.76.23 13.83z" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const externalIcon = __component__.exports;
export {
  externalIcon as default
};
